<template>
  <div>
    <Landing />
    <!-- <Socials /> -->
    <div class="social">
      <div class="container">
        <div class="row">
          <div class="col s12 m6 my">
            <img src="@/assets/vectors/socials-3.svg" class="img-responsive" />
          </div>
          <div class="col s12 m6">
            <div class="title">Get in touch</div>
            <p>Follow and thank you for visiting me.</p>

            <div class="collection">
              <!-- <a
                href="https://github.com/kennedybaraka"
                target="_blank"
                class="collection-item"
                ><img
                  src="@/assets/vectors/101.png"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>kennedy baraka</span>.</a
              > -->
              <a
                href="https://gitlab.com/kenhybrid"
                target="_blank"
                class="collection-item"
                ><img
                  src="@/assets/vectors/gitlab.png"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>kenhybrid</span>.</a
              >
              <a
                href="https://www.linkedin.com/in/kennedy-baraka-545411230/"
                target="_blank"
                class="collection-item"
              >
                <img
                  src="@/assets/vectors/102.png"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>kennedy baraka</span>.</a
              >
              <a href="tel:+254799602770" class="collection-item">
                <img
                  src="@/assets/vectors/107.jpeg"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>0799602770</span>.</a
              >
              <a
                href="https://twitter.com/kennedybaraka11"
                class="collection-item"
              >
                <img
                  src="@/assets/vectors/103.png"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>@kennedybaraka11</span>.</a
              >
              <a href="https://wa.me/254799602770" class="collection-item">
                <img
                  src="@/assets/vectors/104.png"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>+254799602770</span>.</a
              >
              <a
                href="mailto:kennedybaraka22@gmail.com"
                target="_blank"
                class="collection-item"
                ><img
                  src="@/assets/vectors/gmail.png"
                  width="15"
                  height="15"
                  style="margin-right: 5px"
                />
                <span>kennedybaraka22@gmail.com</span>.</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Landing from "../components/portfolio/SocialsLanding.vue";
// import Socials from "../components/portfolio/Socials.vue";
// @ is an alias to /src
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";

export default {
  name: "Socials",
  components: {
    Landing,
    // Socials,
  },
  setup() {
    const siteData = reactive({
      title: `Barakadev | socials`,
      description: `My beautiful website`,
    });

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    });
  },
};
</script>
<style scoped>
.social {
  min-height: 100%;
  margin-bottom: 105px;
}
a {
  text-decoration: none;
  color: black;
  font-size: 16px;
  cursor: pointer;
  padding: 10px;
}
.title {
  font-size: 48px;
  font-weight: 600;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.img-responsive {
  width: 100%;
  height: auto;
}
span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
  margin: 5px;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
.collection {
  border: none;
  color: #765cd1;
}
.collection a {
  border: none;
  color: black !important;
  transition: 0.3 ease-in-out;
}
.collection .collection-item:hover {
  background-color: #fff !important;
  /* margin-left: 10px; */
  transition: 0.3 ease;

  font-weight: 600;
  color: #765cd1 !important;
}
.collection-item:hover img {
  transition: 0.3 ease;
  transform: rotate(720deg) !important;
}
</style>
